import { FunctionComponent, h } from 'preact';
import { OrderTrackingStatus } from '../../../services/order-tracking-service';
import { TrackingStatusTranslations } from './tracking-status-consts';
import { useTranslation } from '../../../hooks/use-translation';
import { useMemo } from 'preact/hooks';

interface Props {
	trackingStatus: OrderTrackingStatus;
	numberOfTasksLeftInRun: number;
}

const TrackingStatusBar: FunctionComponent<Props> = ({ trackingStatus, numberOfTasksLeftInRun }) => {
	const { t } = useTranslation();

	const onPreviousOrderMessage = useMemo(() => {
		if (numberOfTasksLeftInRun === 1) {
			return t('TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE');
		}

		return `${t('TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1')} ${numberOfTasksLeftInRun} ${t(
			'TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2'
		)}`;
	}, [numberOfTasksLeftInRun]);

	const status =
		trackingStatus === OrderTrackingStatus.OnPreviousDelivery && numberOfTasksLeftInRun
			? onPreviousOrderMessage
			: t(TrackingStatusTranslations[trackingStatus]);

	return (
		<div className="tracking-status-bar">
			<div className="status-title" tabIndex={0}>
				{t('TRACKING.DELIVERY_STATUS_TITLE')}
			</div>
			<div className="order-status">
				<span data-testid="status-text" tabIndex={0}>
					{status}
				</span>
			</div>
		</div>
	);
};

export default TrackingStatusBar;
